import React, { useMemo } from 'react';
import useToggle from 'hooks/useToggle';
import { TextFieldProps } from '@mui/material/TextField';

import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import FloatInput from './FloatInput';
import PhoneInput from './PhoneInput';
import IntegerInput from './IntegerInput';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

type CustomInputType = 'float' | 'tel' | 'int';

interface TextFieldBaseProps extends Omit<TextFieldProps, 'type'> {
  type?: TextFieldProps['type'] | CustomInputType;
}

const TextFieldBase = React.forwardRef<HTMLDivElement, TextFieldBaseProps>(({ type, slotProps = {}, ...rest }, ref) => {
  const [isRevealedPassword, toggleRevealedPassword] = useToggle();

  const passwordEye = useMemo(
    () => ({
      endAdornment: (
        <InputAdornment position="end">
          <IconButton aria-label="toggle password visibility" onClick={toggleRevealedPassword}>
            {isRevealedPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      ),
    }),
    [isRevealedPassword, toggleRevealedPassword],
  );

  return (
    <TextField
      ref={ref}
      type={isRevealedPassword ? 'text' : type}
      slotProps={{
        input: {
          ...(type === 'password' && passwordEye),
          ...(type === 'float' && { inputComponent: FloatInput }),
          ...(type === 'tel' && { inputComponent: PhoneInput }),
          ...(type === 'int' && { inputComponent: IntegerInput }),
          ...(slotProps.input || {}),
        },

        ...slotProps,
      }}
      {...rest}
    />
  );
});

TextFieldBase.displayName = 'TextFieldBase';

export default TextFieldBase;
